import { Component, OnInit, ChangeDetectorRef, OnDestroy, AfterViewInit } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { TimerObservable } from 'rxjs/observable/TimerObservable';
import { Subscription } from 'rxjs';

import { environment } from './../../../environments/environment';
import { AuthenticationService } from './../../core/services/auth.service';
import { SpinnerService } from '../../core/services/spinner.service';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { RestService } from '../../core/services/rest.service';
import { CarTask } from '../../models/carTask';
import { Router } from '@angular/router';
import { TaskService } from '../../core/services/task.service';
import { Note } from '../../models/note';
import { FeatureService } from '../../core/services/feature.service';
import { Appointment } from '../../models/appointment';
import { User } from '../../models/user';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit, OnDestroy {

    private _mobileQueryListener: () => void;
    mobileQuery: MediaQueryList;
    showSpinner: boolean;
    userName: string;
    newTasks: CarTask[] = [];
    newNotes: Note[] = [];
    notPlannedAppointments: Appointment[] = [];
    dailyAppointments: Appointment[] = [];

    currentUrl: string = '';

    clientId = environment.clientID;

    private autoLogoutSubscription: Subscription;
    private autoGetNewTasks: Subscription;
    private autoGetAppointments: Subscription;
    private autoGetDailyAppointments: Subscription;

    private user: User;

    constructor(private changeDetectorRef: ChangeDetectorRef,
        private media: MediaMatcher,
        public spinnerService: SpinnerService,
        public authService: AuthenticationService,
        private authGuard: AuthGuard,
        private restService: RestService,
        private router: Router,
        private taskService: TaskService,
        public fs: FeatureService) {

        this.mobileQuery = this.media.matchMedia('(max-width: 1000px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        // tslint:disable-next-line: deprecation
        this.mobileQuery.addListener(this._mobileQueryListener);
    }

    ngOnInit(): void {
        this.user = this.authService.getCurrentUser();
        this.userName = this.user.firstName + ' ' + this.user.lastName;

        // Auto log-out subscription
        const timer = TimerObservable.create(2000, 5000);
        this.autoLogoutSubscription = timer.subscribe(t => {
            this.authGuard.canActivate();
        });

        const timerNewTasks = TimerObservable.create(2000, 10 * 60 * 1000); //10 minutes
        this.autoGetNewTasks = timerNewTasks.subscribe(t => {
            this.getNewTasks();
        });

        if (this.fs.hasFeature("APPOINTMENT")) {
            const timerAppointments = TimerObservable.create(2000, 10 * 60 * 1000); //10 minutes
            this.autoGetAppointments = timerAppointments.subscribe(t => {
                this.getNotPlannedAppointments();
            });

            const timerDailyAppointments = TimerObservable.create(2000, 10 * 60 * 1000); //10 minutes
            this.autoGetDailyAppointments = timerDailyAppointments.subscribe(t => {
                this.getDailyAppointments();
            });
        }
        
        this.currentUrl = this.router.url;
    }

    ngOnDestroy(): void {
        // tslint:disable-next-line: deprecation
        this.mobileQuery.removeListener(this._mobileQueryListener);
        this.autoLogoutSubscription.unsubscribe();
        this.autoGetNewTasks.unsubscribe();
    }

    getNewTasks() {
        //this.restService.getNewTasks().subscribe((data: CarTask[]) => {
        //    this.newTasks = data;
        //});
        this.restService.getNewNotes().subscribe((data: Note[]) => {
            this.newNotes = data;
        });
    }

    getDailyAppointments() {
        this.restService.getDailyAppointments().subscribe((data: Appointment[]) => {
            this.dailyAppointments = data.filter(a => a.commercialId == this.user.id && new Date(a.startDateTime).getTime() >= new Date().getTime());
        });
    }

    getNotPlannedAppointments() {
        this.restService.getNotPlannedAppointments().subscribe((data: Appointment[]) => {
            this.notPlannedAppointments = data;
        });
    }

    taskSeen(task: CarTask) {
        task.seen = true;

        this.restService.updateTask(task).subscribe((data: CarTask[]) => {
            this.getNewTasks();
            this.router.navigate(['/cars']);
            this.taskService.searchTask(task.car);
        });
    }

    planAppointment(appointment: Appointment) {
            this.router.navigate(['/cars/appointments-calendar/' + appointment.id]);
    }

    noteSeen(note: Note) {
        note.seen = true;

        this.restService.updateNote(note).subscribe((data: CarTask[]) => {
            this.getNewTasks();
            this.router.navigate(['/cars']);
            this.taskService.searchTask(note.car);
        });
    }

    newAppointment() {
        this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        }
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['/cars/appointments-calendar/new']);
    }
}
